// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2dMr2","loaderOuter":"PageOverlayLoader_loaderOuter__Qay0N"};